
import { ErrorBoundary } from './ErrorBoundary';
import { ErrorControl } from './ErrorControl';

export {
  ErrorBoundary,
  ErrorControl,
};
export default ErrorBoundary;
